import React, { Component } from 'react'
import styled from 'styled-components'
import 'react-circular-progressbar/dist/styles.css'
import CircularProgressbar from 'react-circular-progressbar'
import { calColor } from '../utlis/functions'
import Cookies from 'js-cookie'
import { DOWNLOAD_URL } from '../constants'
import { ImageWrap, FilteredImage, StyledImage } from './'

const ProgressWrapper = styled.div`
  width: ${props => (props.size ? props.size : '56px')};
  min-width: ${props => (props.size ? props.size : '56px')};
  height: ${props => (props.size ? props.size : '56px')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '50%')};
  background: ${props => (props.backgroundFilled ? '#fff' : 'transparent')};
  position: relative;
  .CircularProgressbar-path {
    stroke-linecap: square !important;
    stroke-width: 16px;
  }
  .CircularProgressbar-trail {
    stroke: #ddd !important;
    stroke-width: 12px;
  }
  ${props =>
    props.flex &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
  `};
`
class ProgressBar extends Component {
  state = {}
  render() {
    const {
      percentage,
      fill,
      size,
      backgroundFilled,
      displayImage,
      borderRadius,
      childComponent,
      flex,
      ...props
    } = this.props
    return (
      <ProgressWrapper
        size={size}
        backgroundFilled={backgroundFilled}
        borderRadius={borderRadius}
        flex={flex}
        {...props}>
        {childComponent}
        {displayImage && (
          <ImageWrap
            style={{
              position: 'absolute',
              top: '6.5px',
              left: '6.5px'
            }}>
            {Cookies.getJSON('userDetails').profileImage !== null && (
              <FilteredImage
                src={
                  Cookies.getJSON('userDetails').profileImage
                    ? `${DOWNLOAD_URL}/${Cookies.getJSON('userDetails').profileImage}`
                    : require('../static/svgs/user.svg')
                }
                alt="profile_img"
              />
            )}
            <StyledImage
              height="30px"
              src={
                Cookies.getJSON('userDetails').profileImage
                  ? `${DOWNLOAD_URL}/${Cookies.getJSON('userDetails').profileImage}`
                  : require('../static/svgs/user.svg')
              }
              alt="profile_img"
            />
          </ImageWrap>
        )}
        <CircularProgressbar
          fill={calColor(percentage)}
          percentage={percentage}
          text={`${percentage}`}
          styles={{
            // Customize the root svg element
            root: {},
            // Customize the path, i.e. the part that's "complete"
            path: {
              // Tweak path color:
              stroke: `${calColor(percentage)}`
            },
            text: {
              // Tweak text color:
              fill: `${calColor(percentage)}`,
              // Tweak text size:
              fontSize: '30px',
              fontFamily: 'Overpass'
            }
          }}
          {...props}
        />
      </ProgressWrapper>
    )
  }
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js